import { Trophy, Play, Sparkles, Star } from "lucide-react";
import { Link } from "react-router-dom";

export const RewardsSection = () => {
  return (
    <section className="rewards-section py-8">
      <div className="mx-auto max-w-4xl">
        <Link
          to="/recompensas"
          className="block relative overflow-hidden rounded-2xl transition-all duration-300 hover:scale-[1.01] hover:shadow-2xl hover:shadow-primary/20 group"
        >
          {/* Animated gradient background */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary via-accent to-primary bg-[length:200%_100%] animate-gradient-shift" />
          
          {/* Overlay for depth */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-black/20" />
          
          {/* Decorative particles */}
          <div className="absolute inset-0 overflow-hidden">
            <Sparkles className="absolute top-4 right-12 h-4 w-4 text-white/30 animate-float" style={{ animationDelay: '0s' }} />
            <Star className="absolute bottom-6 right-24 h-3 w-3 text-white/20 animate-float" style={{ animationDelay: '0.5s' }} />
            <Sparkles className="absolute top-8 left-1/3 h-3 w-3 text-white/20 animate-float" style={{ animationDelay: '1s' }} />
          </div>
          
          {/* Content */}
          <div className="relative p-6 sm:p-8">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                {/* Glowing trophy icon */}
                <div className="relative">
                  <div className="p-3 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 group-hover:bg-white/20 transition-all animate-pulse-glow">
                    <Trophy className="w-7 h-7 sm:w-8 sm:h-8 text-white" />
                  </div>
                  {/* Glow effect */}
                  <div className="absolute inset-0 rounded-xl bg-white/20 blur-xl opacity-50 group-hover:opacity-80 transition-opacity" />
                </div>
                
                <div>
                  <h3 className="text-xl sm:text-2xl text-white font-bold mb-1 group-hover:text-white/90 transition-colors">
                    Recompensas
                  </h3>
                  <p className="text-white/70 text-sm sm:text-base group-hover:text-white/80 transition-colors">
                    Descubre tus logros y desafíos
                  </p>
                </div>
              </div>
              
              {/* Play button */}
              <div className="flex items-center space-x-2">
                <div className="p-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 group-hover:bg-white/20 group-hover:scale-110 transition-all">
                  <Play className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};
